import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AreaMenuItemModule } from '../area-menu-item/area-menu-item.module';
import { AngularUpgradeHelper } from '../helpers/AngularUpgradeHelper';
import { UserInfoModule } from '../userInfo/user-info.module';
import { ConnectionStatusComponent } from './connection-status.component';
import { FlexModule } from '@angular/flex-layout';

@NgModule({
    declarations: [
        ConnectionStatusComponent
    ],
    entryComponents: [
        ConnectionStatusComponent
    ],
    exports: [
        ConnectionStatusComponent
    ],
    imports: [
        CommonModule,
        AreaMenuItemModule,
        UserInfoModule,
        FlexModule
    ],
})
export class ConnectionStatusModule {
    private commonModuleName = 'app.areas.common';

    constructor() {
        AngularUpgradeHelper.downgradeComponents(this.commonModuleName, [
            ConnectionStatusComponent
        ]);
    }
}
